import mdast from 'mdast';

import { SerializeOptions } from '@lumapps/wrex/serialization/markdown/toMarkdown/types';

import { CODE_BLOCK } from '../../constants';

export const CODE_BLOCK_ELEMENTS: SerializeOptions['elements'] = {
    [CODE_BLOCK]: (_, children) => {
        const value = children
            .map((node) => node.value)
            .filter(Boolean)
            .join('');
        return { type: 'code', value } as mdast.Code;
    },
};
